// generated from 17_772 samples

import { z } from "zod";
import { triggerFiltersGetSchema } from "./triggerFiltersGetSchema";

export const purchasedProductWithNestedObjectTriggerGetSchema = z.object({
  event_type: z.literal("TrackedUserBehavior::PurchasedProductWithNestedObject"),
  // null: 86 (0.48%)
  // true 25 (0.14%), false 17_661 (99.86%)
  blocklisted: z.boolean().nullable().optional(),
  // undefined: 14_102 (79.35%), defined 3_670 (20.65%)
  filter_description: z.string().optional(),
  // undefined: 14_102 (79.35%), defined 3_670 (20.65%)
  filters: triggerFiltersGetSchema.optional(),
  // null: 86 (0.48%)
  hard_deleted: z.boolean().nullable().optional(),
  product_name: z.string(),
});
